import Breadcrumbs from "components/Breadcrumbs"
import Image from "components/Image"
import NextImage from "next/image"
import richText from "utilities/richText"
import storyblokImageLoader from "utilities/storyblokImageLoader"

export default function TeamMemberPageHeader({ blok }) {
  return (
    <header className="md:py-12 relative overflow-hidden bg-primary">
      {blok?.content?.content?.length > 1 ? (
        <>
          <NextImage
            alt=""
            src="/assets/blue-weave.webp"
            quality={80}
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMUUvGoBwABzQD/+RWwWwAAAABJRU5ErkJggg=="
            fill
            sizes="100vw"
            style={{
              objectFit: "cover",
            }}
            priority
            aria-hidden
          />
        </>
      ) : (
        <>
          <NextImage
            alt=""
            src="/assets/blue-weave-crop.webp"
            quality={80}
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMUUvGoBwABzQD/+RWwWwAAAABJRU5ErkJggg=="
            fill
            sizes="100vw"
            style={{
              objectFit: "cover",
            }}
            priority
            aria-hidden
          />
        </>
      )}
      <div className="md:px-5 pb-7 md:py-7">
        <div className="flex flex-col md:flex-row md:gap-x-4 max-w-screen-xl mx-auto ">
          <div className="w-full md:order-last flex items-center justify-center md:basis-1/2">
            <Image
              loader={blok?.image?.filename && blok?.image?.filename !== "" ? storyblokImageLoader : undefined}
              src={
                blok?.image?.filename && blok?.image.filename !== ""
                  ? blok?.image.filename
                  : "/assets/team-member-placeholder.jpg"
              }
              alt={blok?.image?.alt}
              height={630}
              width={435}
              sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw"
              className="bg-highlight-tint relative z-10 w-full"
            />
          </div>

          <div className="z-10 md:basis-1/2 px-5 md:px-0 pt-7 md:pt-0">
            <Breadcrumbs breadcrumbs={blok?.breadcrumbs} />
            <h1 className="text-white py-2 capitalize">{blok.heading}</h1>
            {blok.subheading && (
              <div className="text-white pb-3 text-m3 lg:text-l1 font-primary">{blok.subheading}</div>
            )}
            {blok.content && (
              <div className="text-white prose-headings:text-white prose-headings:pb-4">{richText(blok.content)}</div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
